/* eslint-disable import/prefer-default-export */

export const ERROR_MESSAGE = 'Something went wrong, please try again or contact administrator.';
export const EPIK_V2_URL = 'https://my.epik.io/apps/epikv2/';

export const DATE_FORMATS = {
  DATE_TIME: 'dddd, MMMM Do YYYY, h:mm:ss a',
  DATE_TIME_FULL: 'YYYY-MM-DD HH:mm:ss',
  DATE_ONLY: 'YYYY-MM-DD',
};

export const MODEL_LIST = [
  { name: 'G3-24PEM' },
  { name: '4PTL0/A' },
  { name: '8PTL0/A' },
  { name: '8P3D0/A' },
  { name: '4PTLP/A' },
  { name: '8PTLP/A' },
  { name: '4P3D0/A' },
  { name: '6P3D0/A' },
  { name: '4PTL0/A' },
  { name: '6PTL0/A' },
  { name: '4PTL0/A2M' },
  { name: '8PTL0/A2M' },
  { name: '8PTLP/A2M' },
  { name: '6PTLO/A' },
  { name: 'G3-4PTM10' },
  { name: 'G3-4PTM11' },
  { name: 'G3-4PTM12' },
  { name: 'G3-4PTM20' },
  { name: 'G3-4PTM21' },
  { name: 'G3-4PTM22' },
  { name: 'G3-8PTM10' },
  { name: 'G3-8PTM11' },
  { name: 'G3-8PTM12' },
  { name: 'G3-8PTM20' },
  { name: 'G3-8PTM21' },
  { name: 'G3-8PTM22' },
  { name: '2PTL0/A' },
  { name: 'G3-4S10-A2' },
  { name: 'G3-4S20-A2' },
  { name: 'G3-4S20-A3' },
  { name: 'GRT-G3-4S20' },
  { name: 'PRI-G3-4S20' },
  { name: 'G3-2S20-A3' },
  { name: 'G3-2S20-A4.4' },
  { name: 'G3-4S20-A4.4' },
  { name: 'G3-4S20-A4.2' },
  { name: 'G3-2S10-A2' },
  { name: 'G3-2S20-A2' },
  { name: 'G3-2S20-A4.2' },
  { name: 'G3-8S20-A4.2' },
  { name: 'G3-8S10-A4.2' },
  { name: 'G3-4S10-A4.2' },
  { name: 'G3-8S20-A3' },
  { name: 'G3-8S20-A4.4' },
  { name: 'GRT-G3-8S20.NE-A/V' },
  { name: 'GRT-G3-8S20.NE-T/V' },
  { name: 'GRT-G3-8S20.QE-A/V' },
  { name: 'GRT-G3-8S20.QE-T/V' },
  { name: 'GRT-G3-8S20.QE-CA' },
  { name: 'GRT-G3-8S20.QO-A/V' },
  { name: 'GRT-G3-8S20.QO-T/V' },
  { name: 'PRI-G3-8S20' },
  { name: 'GRT-G3-8S20.QEHV-A/V' },
  { name: 'GRT-G3-8S20.QEHV-T/V' },
  { name: 'G4-4100' },
  { name: 'Special Box' },
  { name: 'PRI-G3-8S21-A3e.q' }
];

export const MODEM_LIST = [{ name: 'Nimbelink' }, { name: 'Quectel' }, { name: 'legacy' }];

export const FIRM_TYPES = [
  { label: 'Standard', value: 'wd-v2' },
  { label: 'Unified', value: 'wd-v3' },
];

export const COMPANY_TYPE_DROPDOWN = [
  { label: 'Customer', value: 'retail' },
  { label: 'Channel Partner', value: 'agency' },
  { label: 'Wholesale Partner', value: 'reseller' },
  { label: 'Channel Customer', value: 'partner' },
  { label: 'Manufacturer', value: 'manufacturer' },
];

export const VMAIL_ROUTE = { gateway: 'my.epik.io:5080', route: '1484' };
export const T37_INTELIQUENT_TRUNK = 'LSANCARCGR6_3590';
export const T37_VOICETEL_ROUTE = { route: '1941', gateway: '208.65.249.113:5080' };

export const NUMBER_TYPES = [
  { label: 'Alarm', value: 'alarm', active: true },
  { label: 'Dialout', value: 'dialout', active: true },
  { label: 'Secure Entry', value: 'secureEntry', active: true },
  { label: 'Elevator', value: 'elevator', active: true },
  { label: 'Fax - Standard (T.38)', value: 'faxStandard', active: true },
  { label: 'Fire Alarm', value: 'fireAlarm', active: true },
  { label: 'Hunt', value: 'hunt', active: true },
  { label: 'Modem', value: 'modem', active: true },
  { label: 'Modem Hunt', value: 'modemHunt', active: true },
  { label: 'Page', value: 'page', active: true },
  { label: 'Ring Down', value: 'ringDown', active: true },
  { label: 'Unassigned', value: 'unassigned', active: true },
  { label: 'Voice', value: 'voice', active: true },
  { label: 'Custom', value: 'custom', active: true },
  { label: 'Fax Relay Protocol (T.37)', value: 'fax', active: true },
  { label: 'Dial Tone Only', value: 'dialToneOnly', active: true },
  { label: 'Fax Hunt', value: 't38hunt', active: true },
];
export const NUMBER_TYPES_LABEL = {
  alarm: 'Alarm',
  dialout: 'Dialout',
  secureEntry: 'Secure Entry',
  elevator: 'Elevator',
  faxStandard: 'Fax - Standard (T.38)',
  fireAlarm: 'Fire Alarm',
  hunt: 'Hunt',
  modem: 'Modem',
  modemHunt: 'Modem Hunt',
  page: 'Page',
  ringDown: 'Ring Down',
  unassigned: 'Unassigned',
  voice: 'Voice',
  custom: 'Custom',
  fax: 'Fax Relay Protocol (T.37)',
  vmail: 'Voice Mail',
  forward: 'Forward',
  callIdMask: 'Call ID Mask',
  dialToneOnly: 'Dial Tone Only',
  tollFree: 'Toll Free',
  t38hunt: 'Fax Hunt'
};

export const VMAIL_PROPERTY = { label: 'Voice Mail', value: 'vmail', active: true };

export const FORWARD_PROPERTY = { label: 'Forward', value: 'forward' };

export const TOLL_FREE_PROPERTY = { label: 'Toll Free', value: 'tollFree', active: true }

export const PHONE_NUMBER_TYPES = [
  { label: 'Unassigned', value: 'unassigned' },
  { label: 'Ring Group', value: 'ringGroup' },
  { label: 'Voice', value: 'voice' },
  { label: 'Hunt', value: 'hunt' },
];

export const SWITCH_HEADERS = [
  'Device Online',
  'Registered',
  'Register Config Created',
  'EPI MACS Discovered',
  'Edge Device Online',
];
export const SWITCH_MAC_ADDRESS_ARRAY = [
  '250',
  '251',
  '252',
  '253',
  '230',
  '231',
  '232',
  '233',
  '234',
  '235',
  '236',
  '237',
  '238',
  '239',
  '240',
  '241',
];

export const ENG_LOCALE = {
  // Options.jsx
  items_per_page: 'Article / Page',
  jump_to: 'Skip to',
  jump_to_confirm: 'Sure',
  page: 'Page',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Back 5 Pages',
  next_5: '5 Pages Forward',
  prev_3: 'Back 3 Pages',
  next_3: '3 Pages Forward',
  page_size: 'Page Number',
};

export const E911ModalType = {
  BOX: 'box',
  SIP: 'sip',
  PRI: 'pri',
};

export const ESysInfoAction = {
  OLD: 'monitor',
  NEW: 'sysInfo',
};

export const DATA_LATENCY_TYPE = {
  GET_LATENCY: 'getLatency',
  UPDATE_LATENCY: 'updateLatency',
};

export const TOOLTIPS_TEXT = {
  RESET_BOX_TO_DEFAULT: 'Resets all options and ports of the epikbox',
  ENABLE_EXP_MODULE:
    'Enables daisy chain for a secondary EPIK Device. NOTE: This function is no longer supported for new deployments.',
  ENABLE_ADVANCED_ROUTING:
    'Configures all call traffic to route through an enhanced routing protocol for this device.',
  ENABLE_ENH_FAX: 'Empty for now',
  ADV_MONITORING:
    'Turns on Advanced monitoring diagnostics if Device Monitoring is enabled. WARNING: Do no enable Advanced Monitoring without prior authorization from Tier 3 support. Advanced Monitoring could cause high bandwidth utilization if running on 4G LTE.',
  PORT_ALERT:
    'Sends port level alerts if a specific port goes into an error state. Must also enable Monitoring under the specific ports to have alerting turned on.',
  OFFLINE_PROV:
    'Allows the EPIK Edge Device to Automaically download updated Port provisioning when it comes online. DO NOT ENABLE IF DEVICE HAS CUSTOM SETTINGS',
  MONITORING: 'Enables Device Monitoring which will trigger alerts for offline devices.',
  SECONDARY_TUNNEL: 'Routes ATA`s Internet Traffic through the Epik Edge to bypass local firewalls',
  STAR_CODES:
    'Enables Star Code Features on the EPIK Edge Device (Example: Last number call forwarding using *70)',
    BOX_OFFLINE_CALL_FORWARD:'Enables Box offline Call Forward',
    
  SIM_PRIOR: 'Established which SIM position should be the default 4G service carrier',
  ACTIVE_SIM: 'Displays which SIM card is Active (SIM 1 or SIM 2)',
  INTERFACE_PRIOR: 'Allows the user to select which interface should act as the default connection',
  CURRENT_APN: 'Displays the current APN to which the 4G LTE network is registered',
  APN: 'Allows the user to update or edit APN settings',
  ENABLE_CALL_RECOR: 'Enables call recording for 24 hours on ports set as Alarm, Fire, & Modem. ',
  EPIK_PROV:
    'Enables the ATA to register to the EPIK provisioning services rather than third part provisioning',
  ENABLE_SIP:
    'Turns on CAS and PRI support in the MyEPIK Portal. Only to be used for PRI or CAS enabled devices',
  DATA_CENTER:
    'View the average latency to each data center and update the data center the device connects to.',
  FORWARD_NUM: 'Enables call forwarding on the port to the number entered. ',
  MONITOR:
    'If Port Alerts is enabled on Options tab, will enable this port to send alerts if it goes offline',
  OUT_NUM_OVER:
    'Allows an Administrator to override the outbound number being called on that port and forces the port to call a dedicated number',
  PORT_ENABLE:
    'Allows users to enable/Disable specific ports of an EPIK Edge Device. If Disabled, services will stop working on the disabled port, including voltage and dialtone. Note: Doing so can trigger alarm panel notifications, which can result in Truck roll to site if note in test mode.',
  E1_IP_TYPE: 'Sets whether Ethernet port E1 is using DHCP or Static IP address',
  E2_DHCP: 'Sets Ethernet Port E2 to provide DHCP. ',
  PORT_FORWARD: 'Allows an Administrator to setup network port forwarding rules. ',
  SIM_ACT_CHECK: 'Runs a check for SIM activation with the 4G carrier',
  MODEM_CHECK_UTILITY:
    'Runs a check to make sure the SIM cards are activated and can be swapped in a failover scenario',
  DEVICE_SWAP:
    'Moves configuration data from current EPIK Edge device to another EPIK Edge Device, including Options, Networking, OOBM, Port Features, and notes. Triggers a new integration on the destination device. To be used if a Device is being replaced with a new Serial Number',
  FORWARD_NUMBER: 'Enables call forwarding on the port to the number entered.',
  OUTBOUND_OVERRIDE:
    'Allows an Administrator to override the outbound number being called on that port and forces the port to call a dedicated number',
  APR_COMPANION:
    'If there are two Fire Life Safety ports on the device, this feature allows you to disable the companion port so the alarm test only goes out one path and does not fail over to the secondary path.',
  DEMO_BOX: 'Disabled Port Activation requirements and Integration',
  ADV_MODEM_CONFIG:
    'This will set TX/RX to -5/-5 on the port and sets Silence Detect to Low under Port Configuration settings.',
  BOX_REGISTRAR_CHANGE: 'Configure Box to Registar with New Registration Servers',
  DC_AUTO_SWITCH:
    'When a DC goes down, auto select other DC with next best latency',
  ACTIVE_CARRIER: 'Displays the active carrier',
  APN_MANAGEMENT: 'You can set carrier APNs',
  Band_MANAGEMENT: 'Enables remote administration of a connected USB or IP endpoint',
  LEADING9: 'Automatically removes the leading 9 from the dial plan to get an outside line. This feature will delay calls by 5 seconds.',
  SEND_TONE: 'Sends an audible 60 second locator tone to device',
  INTERNATIONAL_DIALING: 'Enables the dialing rules to allow International calling.',
  DISABLE_E3: 'This disables the Ethernet connection on the last EPI in the device, thus rendering E3 unable to be connected to.',
  ENABLE_IPV6:
    'Enables or disables the IPv6 option on the selected device. Failover uses this flag to apply IPv6 on the network stack.',
  DBCA_ALERT: 'Direct box contact alert.',
  EPI_TIMEZONE: 'This timezone is only for EPIs',
  ATTESTATION_C: 'Change setting for how calls marked with Attestation C will be handled by system',
  EPIK_LAB_BOX: 'Flag on all the devices in the lab, making it easier to only update and test them first.',

//IT DONE:
BLOCK_INBOUND_CALL:'Blocks all inbound calls',
ADV_ENABLE_CALL_OVER_RIDER_ALARAM:'Displays the selected number as the Caller ID for outbound calls',
BLOCK_CALLER_ID:'Blocks Caller ID from being displayed on outbound calls',
ADV_ENABLE_CUSTOMER_CALLER_ID_NAME:'Outbound Caller ID. 15 Character Limit',
ADV_EPIK_CLOUD:'Activates fax relay services via the EPIK cloud service',
FALL_BACK_EMAIL:'Notifies when a fax is retried (only applies to legacy faxing)',
USER_EXPORT_DATA:"User Data",
SECURE_CONNECTION:`Determines at what latency occurring on the secure connection will trigger a failover to the next interface.`,
MAX_AVERAGE_LATENCY:`Determines at what latency occurring on an interface will trigger a failover to the next interface.`,
PING_COUNT:`Determines how many cycles of checks will be averaged to determine failover or restoration to an interface.`,
MISSED_PKT_VALUE:`Determines what latency a missed packet will be considered when calculating average latency.`,
MINIMUM_IMPROVEMENT:`Determines the minimum improvement in average latency that must occur before a device restores an interface connection.`,
CALL_FORWARD_BUSY:"Forwards incoming calls to another number when the line is busy.",
CALL_FORWARD_NO_ANSWER:"Forwards calls to another number when a line is unanswered after a set number of seconds.",
CALL_FORWARD_ALWAYS:"Forwards all incoming calls to another number automatically.",    
DO_NOT_DISTURB:"Silences all incoming calls and sends them directly a busy signal.",
ANONYMOUS_CALL_REJECTION:"Blocks incoming calls that have no caller ID or are marked “Private” or “Anonymous.”",
CALL_BLOCKING:"Blocks incoming calls from specific phone numbers added to the blocked list.",
Minimum: `20 Max: 500 Default: 50`,
SECURE_CONNECTION_PING_THRESHOLD:`How many secure connection failures before a failover is attempted to next interface. Default is 7.`,
PING_HOST:`Primary IP used for failover pings.`,
BACKUP_PING_HOST_LAST_OCTET:`Last octet of Backup IP used for failover pings.`,

};

export const VALIDATION_TEXT = {
ENTERPRISE_GROUP_NAME:"Group Name is required",
ENTERPRISE_GROUP_COMPANY:"Management Company is required"
}

export const USER_VALIDATION_TEXT = {
  NAME:"Name is required",
  EMAIL:"Email is required",
  PASSWORD:"Password is required",
  PERMISSIONS_GROUP:"Permission Group is required",
  }

export const DEVICE_LOCK_BY_SOMEONE = 'Device is currently locked for use by another User'
export const VOICEMAIL_DISABLED = 'Voicemail disabled successfully'
export const PENDING_FAX_AVAILABLE = "Port configuration is temporarily blocked because Fax service is in progress."
export const ETH3_WARNING_TEXT = "The EPI will need to be rebooted. This will cause a momentary disruption of service for approximately 3 minutes. "
export const FAILOVER_COMMANDS = ['install_failover', 'start_failover', 'restart_failover', 'failover_status', 'disable_failover', 'enable_failover', 'stop_failover', 'review_failover_log', 'lte_24_hour_log']
export const COMPANY_GROUP_MODAL = {
  GROUP_NAME: 'Group Name is required',
  GROUP: 'Group is required',
  MANAGMENT_COMPANY: 'Managment Company is required',
}
export const COMPANY_MODAL = {
  COMPANY_NAME: 'Company Name is required',
}
export const MODEL_EPI = {
  '1': [
    '2PTL0/A', 'G3-2S20-A3', 'G3-2S20-A4.4', 'G3-2S10-A2', 'G3-2S20-A4.2', '2S20', '2S10'
  ],
  '2': [
    '4PTL0/A', '4PTLP/A', '4P3D0/A', '4PTL0/A2M', 'G3-4PTM10', 'G3-4PTM11', 
    'G3-4PTM12', 'G3-4PTM20', 'G3-4PTM21', 'G3-4PTM22', 'G3-4S10-A2', 
    'G3-4S20-A2', 'G3-4S20-A3', 'G3-4S20-A4.4', 'G3-4S20-A4.2', 'G3-4S10-A4.2', 
    'G4-4100', '4S20', '4S10',
    'GRT-G3-4S20', 'PRI-G3-4S20'
  ],
  '3': [
    '6PTLO/A', '6PTL0/A'
  ],
  '4': [
    '8PTL0/A', '8PTL0/A2M', '8P3D0/A', '8PTLP/A', '8PTLP/A2M', 'G3-8PTM10', 
    'G3-8PTM11', 'G3-8PTM12', 'G3-8PTM20', 'G3-8PTM21', 'G3-8PTM22', 
    'G3-8S20-A4.2', 'G3-8S10-A4.2', 'G3-8S20-A3e', 'G3-8S20-A4.4', '[G3-8P-2SIM-0PRI-APU3-Escene] G3-8S20-A3e', 'G3-8S20-A3', '8S20', 'G3-8S10-A4', 'G3-8S20-A4', '8S10',
    'PRI-G3-8S21-A3e.q',
    'GRT-G3-8S20.NE-A/V',
    'GRT-G3-8S20.NE-T/V',
    'GRT-G3-8S20.QE-A/V',
    'GRT-G3-8S20.QE-T/V',
    'GRT-G3-8S20.QE-CA',
    'GRT-G3-8S20.QO-A/V',
    'GRT-G3-8S20.QO-T/V',
    'PRI-G3-8S20',
    'GRT-G3-8S20.QEHV-A/V',
    'GRT-G3-8S20.QEHV-T/V'
  ]
};
